var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnRefresh = function SvgIcnRefresh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chat/Rollback"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "#C6C8CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M5.63311 5C5.98374 5 6.26562 5.28756 6.26562 5.64163V7.1377C6.97999 6.26172 7.80249 5 10.0662 5C12.7862 5 15 7.24285 15 10C15 12.7572 12.7862 15 10.0662 15C7.92998 15 6.04624 13.6173 5.37749 11.5588C5.26685 11.2161 5.45062 10.8475 5.78874 10.7347C6.12686 10.6207 6.49186 10.8069 6.60313 11.1496C7.09624 12.6691 8.48939 13.6927 10.0669 13.6927C12.0769 13.6927 13.7119 12.0364 13.7119 9.99813C13.7119 7.95987 12.0769 6.31174 10.0669 6.31174C8.64374 6.31174 7.85311 7.20927 7.20812 8.15049H8.79937C9.14936 8.15049 9.4325 8.43805 9.4325 8.79212C9.4325 9.14682 9.14938 9.43376 8.79937 9.43376H5.63374C5.28375 9.43565 5 9.1481 5 8.79404V5.641C4.99937 5.28756 5.28312 5 5.63311 5Z",
    fill: "#C6C8CC"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnRefresh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_refresh.6e736a71.svg";
export { ForwardRef as ReactComponent };